import { lazy } from 'react';
import { RouteObject } from 'react-router';

// project import
import Loadable from 'components/Loadable';

// render pages
const ReportList = Loadable(lazy(() => import('pages/report/List')));
const ReportCreate = Loadable(lazy(() => import('pages/report/Create')));
const ReportView = Loadable(lazy(() => import('pages/report/View')));
const ReportEdit = Loadable(lazy(() => import('pages/report/Edit')));

// ==============================|| PARTNER SUB ROUTING ||============================== //
const ReportTopicRoutes: RouteObject = {
    path: 'report',
    children: [
        {
            path: '',
            element: <ReportList />,
        },
        {
            path: 'new',
            element: <ReportCreate />,
        },
        {
            path: ':id',
            element: <ReportView />,
        },
        {
            path: ':id/edit',
            element: <ReportEdit />,
        },
    ],
};
export default ReportTopicRoutes;
